export default __webpack_public_path__ + "media/src/assets/images/red_filled-3bca0343fd0984543903dfd34fb0b50c.png";